<template>


<!-- <ActiveBacklog v-if="!details" :lgSize="12" :lgOffset="0" :locParam="1" :idCity="0" @detailView="switchView"  ></ActiveBacklog> -->
<ActiveBacklog2  :lgSize="12" :lgOffset="0" :locParam="1" :idCity="0" :details="0" ></ActiveBacklog2>

</template>

<script>
import ActiveBacklog from "../../components/ActiveBacklog-Column";
import ActiveBacklog2 from "../../components/ActiveBacklog-Stacked";
import Highcharts from "highcharts";

export default {
  name: "dashboard",
  components: {
    ActiveBacklog,
    ActiveBacklog2,
  },
  data: function() {
    return {
      details: false,
    }
  },
  methods: {
    switchView() {
      if(this.details == false) {
        this.details = true;
      } else {
        this.details = false;
      }
    },
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
